import React from 'react'
import PropTypes from 'prop-types'

const CompanyField = ({ company, onChange }) => (
  <div className="field">
    <label style={{ fontSize: '16px' }}>Company name</label>
    <input
      type="text"
      name="company-name"
      placeholder="Company name"
      value={company}
      onChange={onChange}
      required
      style={{ marginBottom: '16px' }}
    />
  </div>
)

CompanyField.propTypes = {
  company: PropTypes.string,
  onChange: PropTypes.func,
}

export default CompanyField



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/AccountCompletionForm/CompanyField/index.js